import React, {
  useEffect,
  useState,
  useCallback,
  useMemo,
  useRef,
} from "react";
import {
  Box,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  Chip,
  CircularProgress,
  Alert,
  Grid,
  Divider,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Stack,
  IconButton,
  Tooltip,
  LinearProgress,
  Autocomplete,
  TextField,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  useMediaQuery,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import axios from "axios";
import EventIcon from "@mui/icons-material/Event";
import CloudDoneIcon from "@mui/icons-material/CloudDone";
import CloudOffIcon from "@mui/icons-material/CloudOff";
import RefreshIcon from "@mui/icons-material/Refresh";
import dayjs from "dayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import duration from "dayjs/plugin/duration";
import CancelIcon from "@mui/icons-material/Cancel";
import AccessTimeFilledIcon from "@mui/icons-material/AccessTimeFilled";
import AddIcon from "@mui/icons-material/Add";
import BeachAccessIcon from "@mui/icons-material/BeachAccess";
import db from "../db";
//* Vacation dialog for draft for now !
// import VacationDialog from "../components/VacationDialog";
import EmployeeEntryDialog from "../components/EmployeeEntryDialog";

import { SupervisorUid } from "../components/constants";

// coloring records
import { LEAVE_COLOR, getStampColor} from "../components/constants";

import {
  generateMonthDates,
  mapAttendanceRows,
  calculateTotalHours,
} from "../utils/attendanceUtils";

//legend colors 
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import Popover from "@mui/material/Popover";

import { useSearchParams } from "react-router-dom";

dayjs.extend(duration);

// Helper: show first N words of the address, reveal full text on hover via Tooltip
const previewAddress = (addr, words = 4) => {
  if (!addr) return "";
  const parts = String(addr).trim().split(/\s+/);
  return parts.length <= words ? addr : `${parts.slice(0, words).join(" ")}...`;
};

const isIncompleteTime = (timeStr, dateStr) => {
  if (!timeStr) return false;
  if (!dateStr || !dayjs(dateStr).isBefore(dayjs(), "day")) return false;

  const s = String(timeStr).trim();

  // ✅ treat "01:05,01:30" as "01:05 ~ 01:30"
  if (s.includes(",") && !s.includes("~")) {
    const parts = s
      .split(",")
      .map((p) => p.trim())
      .filter(Boolean);
    if (parts.length >= 2) return false;
  }

  const parts = s.split(",").map((p) => p.trim());
  return parts.some((p) => !p.includes("~") && !p.includes(","));
};

// ✅ NEW: flags a working day (per schedule) before today with no attendance AND no leave/vacation at all
const isMissingRecord = (row) => {
  if (!row?.date) return false;
  if (!dayjs(row.date).isBefore(dayjs(), "day")) return false; // only days strictly before today

  // Scheduled off day (weekends per THIS employee's schedule, e.g. Friday-off) → skip
  if (row.status === "Weekend") return false;

  // Any vacation/leave request that day (pending or approved) → skip
  if (typeof row.status === "string" && row.status.startsWith("Vacation")) return false;
  if (row.isLeave) return false;

  const t = String(row.time || "").trim();
  return !t || t === "-" || t === "—"; // truly nothing recorded
};

const normalizeBaseUrl = (raw) => {
  const s = String(raw || "")
    .trim()
    .replace(/\/+$/, "");
  if (!s) return "";
  if (/^https?:\/\//i.test(s)) return s;
  // إذا IP:PORT فقط
  return `http://${s}`;
};

export default function MyAttPage() {
  const [openDialog, setOpenDialog] = useState(false);
  const [vacationDate, setVacationDate] = useState(null);
  const [remark, setRemark] = useState("");
  const [requestedDates, setRequestedDates] = useState([]);
  const [hoveredRow, setHoveredRow] = useState(null);

  const [rows, setRows] = useState([]);
  const [filteredRows, setFilteredRows] = useState([]);
  const [loading, setLoading] = useState(true);
  const [fetching, setFetching] = useState(false); // for top bar refresh spinner
  const [error, setError] = useState("");
  const [totalHours, setTotalHours] = useState(0);
  const [acceptedLeave, setAcceptedLeave] = useState([]);
  const [totalLeave, setTotalLeave] = useState(null);
  const [remainingLeave, setRemainingLeave] = useState(null);
  const [online, setOnline] = useState(navigator.onLine);
// leave Items!!!
  const [leaveItems, setLeaveItems] = useState([]);
  const [incompleteCount, setIncompleteCount] = useState(0);
 
// leave details , effective date: bonus, starting balance   
  const [leaveDetail, setLeaveDetail] = useState(null);
  const isXs = useMediaQuery("(max-width:600px)");

// for missing values send a message ! 
 const [missingCount, setMissingCount] = useState(0); 

 // to transform empid to uid 
 const [currentEmpId, setCurrentEmpId] = useState("");

  const today = dayjs();
  const [selectedDate, setSelectedDate] = useState(
    dayjs(`${today.year()}-${today.month() + 1}-01`),
  );

  // searchParams to read the URL (?filter=issues)
  // setSearchParams to change it
  const [filterBy, setFilterBy] = useState("all");
  const [searchParams, setSearchParams] = useSearchParams();
  // runs when the page opens (and whenever the URL changes). If the URL has filter=issues, 
  // incomplete or missing, it applies that filter automatically.
  useEffect(() => {
    const f = searchParams.get("filter");
    if (f === "issues" || f === "incomplete" || f === "missing") setFilterBy(f);
  }, [searchParams]);


  // ✅ Employees filter
  const [employees, setEmployees] = useState([]);
  const [employeesLoading, setEmployeesLoading] = useState(false);
  const [selectedEmployee, setSelectedEmployee] = useState(null);

  // ✅ Auto-select guards
  const didAutoSelectRef = useRef(false);
  const userTouchedEmpRef = useRef(false);
  const [vacationRawTime, setVacationRawTime] = useState("");
  const [vacationRawStatus, setVacationRawStatus] = useState("");
  const [vacationStampModules, setVacationStampModules] = useState("");

  // legend color 
    const [legendAnchor, setLegendAnchor]= useState(null);
    const legendOpen = Boolean(legendAnchor);

  
//mhmd
  // const vacancyCount = useMemo(
  //   () => filteredRows.filter((row) => row.status === "Vacation").length,
  //   [filteredRows],
  // );

  // Online/offline indicator
  useEffect(() => {
    const goOnline = () => setOnline(true);
    const goOffline = () => setOnline(false);
    window.addEventListener("online", goOnline);
    window.addEventListener("offline", goOffline);
    return () => {
      window.removeEventListener("online", goOnline);
      window.removeEventListener("offline", goOffline);
    };
  }, []);

  // Load locally requested dates
  useEffect(() => {
    const loadRequestedVacancies = async () => {
      const all = await db.vacationRequests.toArray();
      const dates = all.map((v) => v.date);
      setRequestedDates(dates);
    };
    loadRequestedVacancies();
  }, [rows]);

  const API_BASE_URL = normalizeBaseUrl(
    localStorage.getItem("saved_sett_api_url"),
  );
  const androidId = localStorage.getItem("saved_sett_mobilenumber") || "";

  // ✅ Load employees from API
  const fetchEmployees = useCallback(async () => {
    if (!API_BASE_URL) return;

    setEmployeesLoading(true);
    try {
      const res = await axios.get(`${API_BASE_URL}/api/employees`, {
        params: { excludeUids: SupervisorUid.join(",") },
      });
      const data = res.data?.data || [];

      const mapped = data
        .filter((x) => x && (x.empId || x.EmpId))
        .map((x) => ({
          empId: Number(x.empId ?? x.EmpId),
          fullName: String(
            x.fullName ?? x.FullName ?? x.full_name ?? "",
          ).trim(),
        }))
        .filter((x) => x.empId && x.fullName);

      mapped.sort((a, b) => a.fullName.localeCompare(b.fullName));
      setEmployees(mapped);
    } catch (e) {
      console.error("Failed to load employees:", e);
    } finally {
      setEmployeesLoading(false);
    }
  }, [API_BASE_URL]);

  useEffect(() => {
    fetchEmployees();
  }, [fetchEmployees]);

  // ✅ Auto-select default employee using empId saved from login (shared_empid)
  useEffect(() => {
    if (didAutoSelectRef.current) return;
    if (userTouchedEmpRef.current) return;
    if (!employees.length) return;

    // إذا المستخدم مختار مسبقاً، لا تغيّر
    if (selectedEmployee) {
      didAutoSelectRef.current = true;
      return;
    }

    const loginEmpIdRaw = localStorage.getItem("shared_empid") || "";
    const loginEmpId = Number(String(loginEmpIdRaw).trim());
    if (!loginEmpId) return;

    const found = employees.find((e) => Number(e.empId) === loginEmpId);
    if (!found) {
      didAutoSelectRef.current = true; // خلّص محاولة
      return;
    }

    setSelectedEmployee(found);
    didAutoSelectRef.current = true;
  }, [employees, selectedEmployee]);

  const fetchData = useCallback(async () => {
    if (!API_BASE_URL) {
      setError("API base URL is not set in settings.");
      setLoading(false);
      return;
    }

    const month = selectedDate.month() + 1;
    const year = selectedDate.year();

    setError("");
    setFetching(true);
    setLoading(true);
  //* RETRIVES FROM CLOUD AND STORES LOCALLY 
    try {
      const effectiveEmpId = selectedEmployee?.empId
        ? Number(selectedEmployee.empId)
        : null;
      const effectiveAndroidId = effectiveEmpId
        ? String(effectiveEmpId)
        : androidId;
      //* ONLINE : FETCH FROM SERVER -> STORE IN INDEXEDDB
      const res = await axios.get(`${API_BASE_URL}/api/attendance`, {
        params: {
          androidId: effectiveAndroidId,
          month,
          year,
          empId: effectiveEmpId || undefined,
        },
      });
    
      // const { data, AcceptedLeave, totalLeave: tl, remainingLeave: rl } = res.data || {};
      // if (tl != null) setTotalLeave(tl);
      // if (rl != null) setRemainingLeave(rl);

    //  leave item fetchData
     const { data, AcceptedLeave, leavesInfo } = res.data || {};

    // !!!Just filter out deleted ones before storing them 
    const filteredLeave = (AcceptedLeave || []).filter(
      (leave) => leave.LeaveStatus !== 4 && leave.status !==4
    )

      // ✅ Always set rows first
      setRows(data || []);
      setAcceptedLeave(AcceptedLeave || []);

      if (leavesInfo) {
        setTotalLeave(leavesInfo.total_days ?? null);
        setRemainingLeave(leavesInfo.total_remaining ?? null);
        setLeaveItems(leavesInfo.items || []);
      }

      

      // Cache in Dexie
      try {
        //* STORE IN DEXIE (INDEXDB)
        await db.transaction(
          "rw",
          db.myattendance,
          db.acceptedLeave,
          async () => {
            //* CLEAR OLD LOCAL DATA 
            await db.myattendance.clear(); 
            await db.acceptedLeave.clear();

            //* STORE NEW DATA LOCALLY
            await db.myattendance.bulkAdd(
              (data || []).map((item) => ({
                datein: item.datein,
                timein: item.timein,
                addressin: item.addressin,
                status: item.status,
                stampmodules: item.stampmodules,
              })),
            );

            await db.acceptedLeave.bulkAdd(
              (AcceptedLeave || []).map((leave) => ({
                EmpId: leave.EmpId,
                JobNo: leave.JobNo,
                FromDate: leave.FromDate,
                ToDate: leave.ToDate,
                FromTime: leave.FromTime,
                ToTime: leave.ToTime,
                LeaveStatus: leave.LeaveStatus,
                LeaveType: leave.LeaveTypeDesc,
                Remark: leave.Remark,
              })),
            );
          },
        );
      } catch (e) {
        console.error("Dexie storage error:", e);
      }
     // !!!!
      // setRows(data || []);
      // setAcceptedLeave(AcceptedLeave || []);
    } catch (err) {
      setError("Offline mode: showing last saved data.");

      //* OFFLINE: READ FROM INDEXEDDB
      const cachedDataRaw = await db.myattendance.toArray();
      const cachedData = cachedDataRaw.map(
        ({ addressin, datein, status, timein ,stampmodules}) => ({
          addressin,
          datein,
          status,
          timein,
          stampmodules,
        }),
      );

      const cachedLeave = await db.acceptedLeave.toArray();
      setRows(cachedData);
      setAcceptedLeave(cachedLeave);
    } finally {
      setLoading(false);
      setFetching(false);
    }
  }, [API_BASE_URL, androidId, selectedDate, selectedEmployee]);

  // Initial & month/employee change fetch
  useEffect(() => {
    fetchData();
  }, [fetchData]);

  // Re-map to table rows + totals
  useEffect(() => {
    const monthDates = generateMonthDates(selectedDate);
    // const mappedRows = mapAttendanceRows(monthDates, rows, acceptedLeave);
    const mappedRows = mapAttendanceRows(monthDates, rows, acceptedLeave).map((r) => {
    const raw = rows.find(
      (x) => String(x.datein || "").replace(/\//g, "-").slice(0, 10) === r.date,
    );
    return { ...r, stampModules: raw?.stampmodules || "" };
  });

    const statusValueMap = {
      posted: 1,
      machine: 2,
      site: 3,
      weekend: "Weekend",
      vacation: "Vacation",
    };

    const filtered =
      filterBy === "all"
        ? mappedRows
        //rows that are incomplete or missing (new)
        : filterBy === "issues"
          ? mappedRows.filter((row) => isIncompleteTime(row.time, row.date) || isMissingRecord(row))
        : filterBy === "missing"
          ? mappedRows.filter((row) => isMissingRecord(row))   // NEW branch
          : filterBy === "incomplete"
          ?mappedRows.filter((row) => isIncompleteTime(row.time, row.date))
          : mappedRows.filter((row) => row.status === statusValueMap[filterBy]);

    setFilteredRows(filtered);
    setTotalHours(calculateTotalHours(filtered));
  }, [rows, acceptedLeave, selectedDate, filterBy]);

  useEffect(() => {
    const count = filteredRows.filter((r) =>
      isIncompleteTime(r.time, r.date),
    ).length;
    setIncompleteCount(count);
  }, [filteredRows]);

  // For missing values 
  useEffect(() => {
  const count = filteredRows.filter((r) => isMissingRecord(r)).length;
  setMissingCount(count);
}, [filteredRows]);

 //* to close the filter of missingrecords !! and return the attendance records
    useEffect(() => {
    const isIssueFilter =
      filterBy === "missing" || filterBy === "incomplete" || filterBy === "issues";
    if (!isIssueFilter || loading || fetching) return;
    if (filteredRows.length > 0) return;
    setFilterBy("all");
    if (searchParams.get("filter")) {
      setSearchParams({}, { replace: true });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filteredRows, filterBy, loading, fetching]);


  // useEffect(() => {
  //   // only acts on the problem filters. Normal filters (posted, machine, weekend...) are never touched.
  //   const isIssueFilter =
  //     filterBy === "missing" || filterBy === "incomplete" || filterBy === "issues";
  //     //waits until the data has finished loading, so it doesn’t jump back while the list is just empty mid-refresh
  //   if (isIssueFilter && !loading && !fetching && filteredRows.length === 0) { // nothing left to fix filteredRows.length === 0
  //     setFilterBy("all");
  //     setSearchParams({});
  //   }
  // }, [filteredRows, filterBy, loading, fetching, setSearchParams]);

useEffect(() => {
  if (!API_BASE_URL) return;
  const uid = localStorage.getItem("saved_username") || "";
  if (!uid) return;

  axios
    .get(`${API_BASE_URL}/api/resolve-empid`, { params: { uid } })
    .then((res) => setCurrentEmpId(String(res.data?.empId ?? "")))
    .catch(() => setCurrentEmpId(""));
}, [API_BASE_URL]);

  // !!!!!!!
  const formatTime = (t) => {
  const s = String(t || "").trim();
  if (!s) return "";

  // ── tagged format: "W:08:00 ~ 09:00,L:09:00 ~ 16:00" ──
  if (s.includes("W:") || s.includes("L:")) {
    return s
      .split(",")
      .map((seg) => seg.trim())
      .filter(Boolean)
      .map((seg) => {
        const timeStr = seg.replace(/^[WL]:/, "").trim();
        return timeStr.replace(/\s*~\s*/g, " ~ ");
      })
      .join(", ");
  }

  // ── legacy flat format ──
  if (s.includes("~")) return s.replace(/\s*~\s*/g, " ~ ");
  if (s.includes(",")) {
    const parts = s.split(",").map((p) => p.trim()).filter(Boolean);
    if (parts.length >= 2) return `${parts[0]} ~ ${parts[1]}`;
    return parts[0] || "";
  }
  return s;
};

// coloring records machine,gps,..
const renderColoredTime = (t, stampModules) => {
  const s = String(t || "").trim();
  if (!s) return "–";

  const modules = String(stampModules || "")
    .split("|")
    .map((v) => parseInt(v.trim(), 10));

  const isTagged = s.includes("W:") || s.includes("L:");
  const segs = isTagged
    ? s.split(",").map((seg) => seg.trim()).filter(Boolean)
    : [`W:${formatTime(s)}`];

  let workIdx = 0;

  // return segs.map((seg, i) => {
  //   const isLeave = seg.startsWith("L:");
  //   const times = seg.replace(/^[WL]:/, "").match(/\d{1,2}:\d{2}/g) || [];
  //   return (
  //     <span key={i}>
  //       {i > 0 && ", "}
  //       {times.map((tm, j) => {
  //         const color = isLeave ? LEAVE_COLOR : getStampColor(modules[workIdx++]);
  //         return (
  //           <span key={j}>
  //             {j > 0 && " ~ "}
  //             <span style={{ color, fontWeight: 800 }}>{tm}</span>
  //           </span>
  //         );
  //       })}
  //     </span>
  //   );
  // });
    return segs.map((seg, i) => {
    const isLeave = seg.startsWith("L:");
    const times = seg.replace(/^[WL]:/, "").match(/\d{1,2}:\d{2}/g) || [];
    return (
      <React.Fragment key={i}>
        {i > 0 && ", "}
        <span style={{ whiteSpace: "nowrap" }}>
          {times.map((tm, j) => {
            const color = isLeave ? LEAVE_COLOR : getStampColor(modules[workIdx++]);
            return (
              <span key={j}>
                {j > 0 && " ~ "}
                <span style={{ color, fontWeight: 800 }}>{tm}</span>
              </span>
            );
          })}
        </span>
      </React.Fragment>
    );
  });
};

  // const parseVacationStatus = (status) => {
  //   if (!status || typeof status !== "string") return null;

  //   if (!status.startsWith("Vacation")) return null;

  //   const parts = status.split(";");
  //   const code = parts[1] ? parts[1].trim() : "";
  //   const leaveType = parts[2] ? parts[2].trim() : "";

  //   return {
  //     isVacation: true,
  //     isApproved: code === "3",
  //     rawCode: code,
  //     leaveType,
  //   };
  // };

  const parseVacationStatus = (status) => {
  if (!status || typeof status !== "string") return null;
  if (!status.startsWith("Vacation")) return null;

  const rest = status.slice("Vacation;".length); // "3:Annual,2:Sickness Paid"
  const entries = rest.split(",").map((entry) => {
    const [code, ...nameParts] = entry.split(":");
    return {
      isApproved: code.trim() === "3",
      rawCode: code.trim(),
      leaveType: nameParts.join(":").trim(),
    };
  }).filter((e) => e.leaveType);

  return { isVacation: true, entries };
};

   // 9/2/26 shaher 9 
// const vacancyCount = useMemo(() => {
//   return filteredRows.reduce((acc, row) => {
//     const vac = parseVacationStatus(row.status);
    
//     if (vac?.isVacation && vac.isApproved) {
//       return acc + 1;
//     }
//     return acc;
//   }, 0);
// }, [filteredRows]);

const vacancyCount = useMemo(() => {
  return filteredRows.reduce((acc, row) => {
    const vac = parseVacationStatus(row.status);
    if (!vac?.entries) return acc;
    return acc + vac.entries.filter((e) => e.isApproved).length;
  }, 0);
}, [filteredRows]);


  const fmtDMY = (s) => (s ? String(s).slice(0, 10).split("-").reverse().join("/") : "");
 // detailRow draws one line of the details box (label, optional small “from” date, value).
  const detailRow = (label, value, opts = {}) => (
    <Stack
      direction="row"
      justifyContent="space-between"
      alignItems="baseline"
      sx={{
        py: 0.5,
        ...(opts.top ? { borderTop: "1px solid #e0e0e0", mt: 0.5, pt: 1 } : {}),
      }}
    >
      <Typography
        variant="body2"
        sx={{ color: opts.bold ? "#004d40" : "text.secondary", fontWeight: opts.bold ? 800 : 400 }}
      >
        {label}
        {opts.sub && (
          <Typography component="span" variant="caption" sx={{ ml: 1, color: "text.disabled" }}>
            {opts.sub}
          </Typography>
        )}
      </Typography>
      <Typography
        variant="body2"
        sx={{ fontWeight: opts.bold ? 800 : 600, color: opts.color || "#004d40" }}
      >
        {value}
      </Typography>
    </Stack>
  );

  return (
    <Box
      sx={{
        minHeight: "100vh",
        display: "flex",
        justifyContent: "center",
        alignItems: "flex-start",
        pt: 4,
        px: 2,
        background: {
          xs: "linear-gradient(180deg, #e0f2f1 0%, #ffffff 40%)",
          md: "linear-gradient(135deg, #e0f2f1 0%, #ffffff 55%)",
        },
      }}
    >
      <Paper
        elevation={10}
        sx={{
          width: "100%",
          maxWidth: 1200,
          borderRadius: 4,
          overflow: "hidden",
          background: "linear-gradient(180deg, #ffffff 0%, #fbfffe 100%)",
          boxShadow: "0 20px 60px rgba(0,0,0,.12)",
          border: "1px solid #b2dfdb",
        }}
      >
        {fetching && <LinearProgress sx={{ borderRadius: "4px 4px 0 0" }} />}

        {/* <Box sx={{ p: 3 }}> */}
        <Box sx={{ p: { xs: 1.5, sm: 3 } }}>
          {/* Header */}
          <Stack
            direction={{ xs: "column", sm: "row" }}
            alignItems={{ xs: "flex-start", sm: "center" }}
            justifyContent="space-between"
            spacing={1.5}
            sx={{ mb: 2 }}
          >
            <Stack direction="row" alignItems="center" spacing={1}>
              <EventIcon sx={{ color: "#00796b" }} />
              <Typography variant="h6" fontWeight={800} color="#004d40">
                Attendance Records
              </Typography>
            </Stack>

            {/* <Stack direction="row" spacing={1}>
              <Chip
                icon={<AccessTimeFilledIcon />}
                label={`Total: ${totalHours.toFixed(2)} hrs`}
                color="success"
                variant="filled"
                sx={{ fontWeight: 700 }}
              />
              <Chip
                icon={online ? <CloudDoneIcon /> : <CloudOffIcon />}
                label={online ? "Online" : "Offline"}
                color={online ? "success" : "warning"}
                variant="outlined"
                sx={{ fontWeight: 700 }}
              />
              <Tooltip title="Refresh">
                <span>
                  <IconButton
                    onClick={fetchData}
                    disabled={fetching}
                    sx={{
                      ml: 0.5,
                      border: "1px solid #b2dfdb",
                      bgcolor: "#f6fffe",
                      "&:hover": { bgcolor: "#eafffd" },
                    }}
                  >
                    <RefreshIcon fontSize="small" />
                  </IconButton>
                </span>
              </Tooltip>
            </Stack> */}
            <Stack direction="row" spacing={1} flexWrap="wrap" useFlexGap sx={{ rowGap: 1 }}>
            <Chip
              icon={<AccessTimeFilledIcon />}
              label={`Total: ${totalHours.toFixed(2)} hrs`}
              color="success"
              variant="filled"
              size="small"
              sx={{ fontWeight: 700, fontSize: { xs: 11, sm: 13 } }}
            />
            <Chip
              icon={online ? <CloudDoneIcon /> : <CloudOffIcon />}
              label={online ? "Online" : "Offline"}
              color={online ? "success" : "warning"}
              variant="outlined"
              size="small"
              sx={{ fontWeight: 700, fontSize: { xs: 11, sm: 13 } }}
            />
            <Tooltip title="Refresh">
              <span>
                <IconButton
                  onClick={fetchData}
                  disabled={fetching}
                  size="small"
                  sx={{
                    border: "1px solid #b2dfdb",
                    bgcolor: "#f6fffe",
                    "&:hover": { bgcolor: "#eafffd" },
                  }}
                >
                  <RefreshIcon fontSize="small" />
                </IconButton>
              </span>
            </Tooltip>
          </Stack>

          </Stack>

          {/* Filters */}
          <Box
            sx={{
              display: "none",
              mb: 2.5,
              p: 2,
              bgcolor: "#f1fdfb",
              border: "1px solid #b2dfdb",
              borderRadius: 2,
            }}
          >
            <Typography variant="subtitle2" sx={{ color: "#00796b", mb: 1 }}>
              Filter by Employee, Month & Category
            </Typography>

            <Grid container spacing={2}>
              {/* Employee */}
              <Grid item xs={12} md={4}>
                <Autocomplete
                  options={employees}
                  value={selectedEmployee}
                  onChange={(_, v, reason) => {
                    // ✅ المستخدم لمس القائمة => لا نعمل override لاحقاً
                    if (reason !== "reset") userTouchedEmpRef.current = true;
                    setSelectedEmployee(v);
                  }}
                  loading={employeesLoading}
                  getOptionLabel={(o) => (o ? `${o.fullName}` : "")}
                  isOptionEqualToValue={(opt, val) =>
                    Number(opt?.empId) === Number(val?.empId)
                  }
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Employee"
                      size="small"
                      variant="outlined"
                      sx={{ backgroundColor: "white", borderRadius: 2 }}
                      InputProps={{
                        ...params.InputProps,
                        endAdornment: (
                          <>
                            {employeesLoading ? (
                              <CircularProgress size={18} />
                            ) : null}
                            {params.InputProps.endAdornment}
                          </>
                        ),
                      }}
                    />
                  )}
                />
                <Typography
                  variant="caption"
                  color="text.secondary"
                  sx={{ display: "block", mt: 0.5 }}
                >
                  Leave empty to show your default (androidId) records.
                </Typography>
              </Grid>

              {/* Month */}
              <Grid item xs={12} md={4}>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DatePicker
                    views={["year", "month"]}
                    label="Select Month"
                    minDate={dayjs("2022-01-01")}
                    maxDate={dayjs("2026-12-31")}
                    value={selectedDate}
                    onChange={(newValue) =>
                      newValue && setSelectedDate(newValue)
                    }
                    slotProps={{
                      textField: {
                        fullWidth: true,
                        size: "small",
                        variant: "outlined",
                        sx: { backgroundColor: "white", borderRadius: 2 },
                      },
                    }}
                  />
                </LocalizationProvider>
              </Grid>

              {/* Category */}
              <Grid item xs={12} md={4}>
                <FormControl size="small" fullWidth>
                  <InputLabel id="filter-label">Filter</InputLabel>
                  <Select
                    labelId="filter-label"
                    value={filterBy}
                    label="Filter"
                    onChange={(e) => setFilterBy(e.target.value)}
                    sx={{
                      backgroundColor: "#f1fdfb",
                      borderRadius: 2,
                    }}
                  >
                    <MenuItem value="all">All</MenuItem>
                    <MenuItem value="posted">Posted</MenuItem>
                    <MenuItem value="machine">Machine</MenuItem>
                    <MenuItem value="site">Site</MenuItem>
                    <MenuItem value="weekend">Weekend</MenuItem>
                    <MenuItem value="vacation">Vacation</MenuItem>
                    <MenuItem value="missing">Missing Record</MenuItem>
                  </Select>
                </FormControl>
              </Grid>
            </Grid>
          </Box>

          {/* Alerts */}
          {error && (
            <Alert severity="warning" sx={{ mb: 2 }}>
              {error}
            </Alert>
          )}

           {incompleteCount > 0 && !SupervisorUid.includes(currentEmpId) &&  (
            <Alert
              severity="error"
              icon={<span style={{ fontSize: 16 }}>⚠</span>}
              sx={{
                mb: 2,
                backgroundColor: "#ffeaea",
                py: { xs: 0.25, sm: 1 },
                px: { xs: 1, sm: 2 },
                "& .MuiAlert-message": {
                  fontSize: { xs: 11, sm: 14 },
                  lineHeight: { xs: 1.3, sm: 1.5 },
                },
                "& .MuiAlert-icon": {
                  fontSize: { xs: 16, sm: 22 },
                  py: { xs: 0.25, sm: 1 },
                  mr: { xs: 0.75, sm: 1 },
                },
              }}
            >
              You have {incompleteCount} incomplete day
              {incompleteCount > 1 ? "s" : ""} before today. Please verify your
              attendance times.     
              <Button 
               size= "small"
               variant = "contained"
               color="error"
               // if came from fingerprintscanner !  
               onClick={() => {
                 if (filterBy === "incomplete" || filterBy === "issues") {
                   setFilterBy("all");
                   setSearchParams({});
                 } else {
                   setFilterBy("incomplete");
                 }
               }}
              //  onClick={() => setFilterBy(filterBy === "incomplete" ? "all" : "incomplete")}
               sx={{ 
                borderRadius: "20px",
                  fontWeight: 700,
                  fontSize: { xs: 10, sm: 13 },
                  textTransform: "none",
                  boxShadow: "none",
                  px: { xs: 1, sm: 2 },
                  py: { xs: 0.25, sm: 0.75 },
                  minWidth: { xs: 0, sm: 64 },
                  minHeight: { xs: 24, sm: 32 },
                "&:hover": {boxShadow: "none" },
              }}
              >
                {filterBy === "incomplete" || filterBy === "issues" ? "Show all" : "Apply"}
              </Button>
            </Alert>
          )}

           {missingCount > 0 && !SupervisorUid.includes(currentEmpId) &&  (
            <Alert
              severity="warning"
              sx={{
                mb: 2,
                backgroundColor: "#fff8e1",
                py: { xs: 0.25, sm: 1 },
                px: { xs: 1, sm: 2 },
                "& .MuiAlert-message": {
                  fontSize: { xs: 11, sm: 14 },
                  lineHeight: { xs: 1.3, sm: 1.5 },
                },
                "& .MuiAlert-icon": {
                  fontSize: { xs: 16, sm: 22 },
                  py: { xs: 0.25, sm: 1 },
                  mr: { xs: 0.75, sm: 1 },
                },
              }}
            >
              You have {missingCount} working day
              {missingCount > 1 ? "s" : ""} before today with no attendance or leave
              record. 
              <Button 
               size="small"
               color="error"
               variant="contained"
               //onClick={() => setFilterBy(filterBy === "missing" ? "all": "missing") }
               onClick={() => {
                 if (filterBy === "missing" || filterBy === "issues") {
                   setFilterBy("all");
                   setSearchParams({});
                 } else {
                   setFilterBy("missing");
                 }
               }}
               sx={{
                  ml: {xs: 0.075, sm:1.5},
                  borderRadius: "20px",
                  fontWeight: 700,
                  fontSize: { xs: 10, sm: 13 },
                  textTransform: "none",
                  boxShadow: "none",
                  px: { xs: 1, sm: 2 },
                  py: { xs: 0.25, sm: 0.75 },
                  minWidth: { xs: 0, sm: 64 },
                  minHeight: { xs: 24, sm: 32 },
                  "&:hover": { boxShadow: "none" },
                }}
              >
                {filterBy === "missing" || filterBy === "issues" ? "Show all" : "Apply"}
              </Button>

            </Alert>
          )}
          
          {/* ===Legend color  */}
          <Popover
            open={legendOpen}
            anchorEl={legendAnchor}
            onClose={() => setLegendAnchor(null)}
            anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
            transformOrigin={{ vertical: "top", horizontal: "center" }}
            PaperProps={{ sx: { borderRadius: 2, p: 1.5, boxShadow: 4 } }}
          >
            <Box sx={{ minWidth: 220 }}>
              <Typography variant="subtitle2" fontWeight={800} sx={{ mb: 1 }}>
                Time color legend
              </Typography>
              <Stack spacing={0.9}>
                <Stack direction="row" spacing={1} alignItems="center">
                  <Box sx={{ width: 12, height: 12, borderRadius: "50%", bgcolor: "#b71c1c" }} />
                  <Typography fontSize={13}>Phone (GPS) entry</Typography>
                </Stack>
                <Stack direction="row" spacing={1} alignItems="center">
                  <Box sx={{ width: 12, height: 12, borderRadius: "50%", bgcolor: "#0d47a1" }} />
                  <Typography fontSize={13}>HR manual entry</Typography>
                </Stack>
                <Stack direction="row" spacing={1} alignItems="center">
                  <Box sx={{ width: 12, height: 12, borderRadius: "50%", bgcolor: "#2e7d32" }} />
                  <Typography fontSize={13}>Employee manual entry</Typography>
                </Stack>
                <Stack direction="row" spacing={1} alignItems="center">
                  <Box sx={{ width: 12, height: 12, borderRadius: "50%", bgcolor: "#e65100" }} />
                  <Typography fontSize={13}>Machine (fingerprint) entry</Typography>
                </Stack>
                <Stack direction="row" spacing={1} alignItems="center">
                  <Box sx={{ width: 12, height: 12, borderRadius: "50%", bgcolor: "#4a148c" }} />
                  <Typography fontSize={13}>Leave</Typography>
                </Stack>
              </Stack>
            </Box>
          </Popover>

          {/* Table Section */}
          {loading ? (
            <Box sx={{ display: "flex", justifyContent: "center", py: 6 }}>
              <CircularProgress />
            </Box>
          ) : filteredRows.length === 0 ? (
            <Paper
              variant="outlined"
              sx={{
                p: 4,
                textAlign: "center",
                borderRadius: 2,
                bgcolor: "#f9fffe",
                borderColor: "#b2dfdb",
              }}
            >
              <Typography
                variant="h6"
                sx={{ fontWeight: 800, color: "#004d40" }}
              >
                No records found for this month
              </Typography>
              <Typography
                variant="body2"
                color="text.secondary"
                sx={{ mt: 0.5 }}
              >
                Try another filter or month.
              </Typography>
            </Paper>
          ) : (
            <TableContainer
              component={Paper}
              elevation={3}
              sx={{
                borderRadius: 2,
                overflow: "auto",
                maxHeight: { xs: 520, md: 580 },
                border: "1px solid #e0f2f1",
              }}
            >
              <Table size="small" stickyHeader>
                <TableHead>
                  <TableRow>
                  
                    <TableCell
                          sx={{
                            backgroundColor: "#00796b",
                            color: "white",
                            width: { xs: "20%", sm: 120 },
                            fontWeight: "bold",
                            fontSize: { xs: 10, sm: 13, md: 14 },
                            textTransform: "uppercase",
                            letterSpacing: 0.5,
                            borderBottom: "1px solid #004d40",
                            py: 1,
                            px: { xs: 0.25, sm: 1 },
                            textAlign: "center",
                          }}
                        >
                          Date
                        </TableCell>
                        <TableCell
                          sx={{
                            backgroundColor: "#00796b",
                            color: "white",
                            width: { xs: "18%", sm: 100 },
                            fontWeight: "bold",
                            fontSize: { xs: 10, sm: 13, md: 14 },
                            textTransform: "uppercase",
                            letterSpacing: 0.5,
                            borderBottom: "1px solid #004d40",
                            py: 1,
                            px: { xs: 0.25, sm: 1 },
                            textAlign: "center",
                          }}
                        >
                          Day
                        </TableCell>
                        <TableCell
                          sx={{
                            backgroundColor: "#00796b",
                            color: "white",
                            width: { xs: "28%", sm: 160 },
                            fontWeight: "bold",
                            fontSize: { xs: 10, sm: 13, md: 14 },
                            textTransform: "uppercase",
                            letterSpacing: 0.5,
                            borderBottom: "1px solid #004d40",
                            py: 1,
                            px: { xs: 0.25, sm: 1 },
                            textAlign: "center",
                            whiteSpace: "nowrap",
                          }}
                        >
                        Time In/Out
                        </TableCell>
                        <TableCell
                          sx={{
                            backgroundColor: "#00796b",
                            color: "white",
                            width: 320,
                            fontWeight: "bold",
                            fontSize: { xs: 10, sm: 13, md: 14 },
                            textTransform: "uppercase",
                            letterSpacing: 0.5,
                            borderBottom: "1px solid #004d40",
                            py: 1,
                            px: 1,
                            display: { xs: "none", sm: "table-cell" },
                            textAlign: "center",
                          }}
                        >
                          Address
                        </TableCell>
                        <TableCell
                          sx={{
                            backgroundColor: "#00796b",
                            color: "white",
                            width: { xs: "22%", sm: 120 },
                            fontWeight: "bold",
                            fontSize: { xs: 10, sm: 13, md: 14 },
                            textTransform: "uppercase",
                            letterSpacing: 0.5,
                            borderBottom: "1px solid #004d40",
                            py: 1,
                            px: { xs: 0.25, sm: 1 },
                            textAlign: "center",
                          }}
                        >
                          Status
                        </TableCell>
                        <TableCell
                          sx={{
                            backgroundColor: "#00796b",
                            color: "white",
                            width: { xs: "22%", sm: 120 },
                            fontWeight: "bold",
                            fontSize: { xs: 10, sm: 13, md: 14 },
                            textTransform: "uppercase",
                            letterSpacing: 0.5,
                            borderBottom: "1px solid #004d40",
                            py: 1,
                            px: { xs: 0.25, sm: 1 },
                            textAlign: "center",
                          }}
                        >
                          <Stack direction="row" alignItems="center" justifyContent="center" spacing={0.5}>
                            <Tooltip title="Color legend">
                              <IconButton
                                size="small"
                                onClick={(e) => setLegendAnchor(e.currentTarget)}
                                sx={{
                                  color: "white",
                                  p: 0.25,
                                  "&:hover": { bgcolor: "rgba(255,255,255,.15)" },
                                }}
                              >
                                <InfoOutlinedIcon sx={{ fontSize: { xs: 14, sm: 18 } }} />
                              </IconButton>
                            </Tooltip>
                          </Stack> 
                        </TableCell>
                        {/* <TableCell
                          sx={{
                            backgroundColor: "#00796b",
                            color: "white",
                            width: { xs: "12%", sm: 60 },
                            fontWeight: "bold",
                            fontSize: { xs: 10, sm: 13, md: 14 },
                            textTransform: "uppercase",
                            letterSpacing: 0.5,
                            borderBottom: "1px solid #004d40",
                            py: 1,
                            px: { xs: 0.25, sm: 1 },
                            textAlign: "center",
                          }}
                        /> */}
                      </TableRow>

                </TableHead>

                <TableBody>
                  {filteredRows.map((row) => {
                    const vac = parseVacationStatus(row.status);
                    const isVacationRow = !!vac?.isVacation;

                    return (
                      <TableRow
                        key={row.date}
                        hover
                        onMouseEnter={() => setHoveredRow(row.date)}
                        onMouseLeave={() => setHoveredRow(null)}
                        sx={{
                          backgroundColor: isIncompleteTime(row.time, row.date)
                            ? "#fff0f0"
                            : isMissingRecord(row)          // ✅ NEW
                             ? "#fff8e1"
                            : "inherit",
                          "&:nth-of-type(odd)": {
                            backgroundColor: isIncompleteTime(
                              row.time,
                              row.date,
                            )
                              ? "#ffeaea"
                               : isMissingRecord(row)        // ✅ NEW
                                 ? "#ffecb3"
                              : "#f8fffe",
                          },
                           borderLeft: isMissingRecord(row) ? "4px solid #f9a825" : "none", 
                           "&.MuiTableRow-hover:hover": {                                   
                            backgroundColor: isIncompleteTime(row.time, row.date)          
                              ? "#ffd6d6"                                                  
                              : isMissingRecord(row)                                       
                                ? "#ffe082"                                                
                                : undefined,                                              
                          },              
                          "&:last-child td, &:last-child th": { border: 0 },
                          "& td": {
                            fontSize: { xs: 8, sm: 13 },
                            py: 0.75,
                            px: { xs: 0.5, sm: 1 },
                            verticalAlign: "top",
                          },
                        }}
                      >
                        <TableCell sx={{ textAlign: "center", whiteSpace: "nowrap" }}>
                          {row.date || ""}
                        </TableCell>
                        <TableCell sx={{ textAlign: "center" }}>
                          {row.day_arabic}
                        </TableCell>

                        <TableCell
                          sx={{ textAlign: "center", fontWeight: 600 }}
                        >
                          {/* {row.time ? formatTime(row.time) : "–"} */}
                          {renderColoredTime(row.time, row.stampModules)}
                        </TableCell>

                        <TableCell
                          sx={{
                            display: { xs: "none", sm: "table-cell" },
                            whiteSpace: "normal",
                            wordBreak: "break-word",
                            textAlign: "center",
                          }}
                        >
                          <Tooltip
                            title={row.address || ""}
                            arrow
                            enterDelay={300}
                            disableHoverListener={!row.address}
                          >
                            <Box
                              component="span"
                              sx={{ cursor: row.address ? "help" : "default" }}
                            >
                              {previewAddress(row.address, 4)}
                            </Box>
                          </Tooltip>
                        </TableCell>

                        {/* ✅ Status */}
                        <TableCell sx={{ textAlign: "center" }}>
                          {(() => {
                            if (vac?.isVacation) {
                              return (
                                <Stack direction="row" spacing={0.5} flexWrap="wrap" justifyContent="center" useFlexGap>
                                  {vac.entries.map((entry, i) => (
                                    <Chip
                                      key={i}
                                      icon={
                                        <Box
                                          sx={{
                                            width: { xs: 6, sm: 10 },
                                            height: { xs: 6, sm: 10 },
                                            borderRadius: "50%",
                                            backgroundColor: entry.isApproved ? "#2e7d32" : "#f57c00",
                                          }}
                                        />
                                      }
                                      label={entry.leaveType}
                                      size="small"
                                      variant="outlined"
                                      sx={{
                                        fontSize: { xs: 8, sm: 12 },
                                        height: { xs: 18, sm: 24 },
                                        fontWeight: 700,
                                        minWidth: { xs: 0, sm: 90 },
                                        justifyContent: "center",
                                        borderColor: entry.isApproved ? "#2e7d32" : "#f57c00",
                                        color: entry.isApproved ? "#2e7d32" : "#f57c00",
                                        "& .MuiChip-icon": { ml: 0.3, mr: 0.3 },
                                      }}
                                    />
                                  ))}
                                </Stack>
                              );
                            }
  
                          {/* {(() => {
                            if (vac?.isVacation) {
                              return (
                                <Chip
                                  icon={
                                    <Box
                                     sx={{
                                        width: { xs: 6, sm: 10 },
                                        height: { xs: 6, sm: 10 },
                                        borderRadius: "50%",
                                        backgroundColor: vac.isApproved ? "#2e7d32" : "#f57c00",
                                      }}
                                    />
                                  }
                                  label={vac.leaveType}
                                  size="small"
                                  variant="outlined"
                                  sx={{
                                    fontSize: { xs: 8, sm: 12 },
                                    height: { xs: 18, sm: 24 },
                                    fontWeight: 700,
                                    minWidth: { xs: 0, sm: 110 },
                                    px: { xs: 0.5, sm: 1 },
                                    justifyContent: "center",
                                    borderColor: vac.isApproved ? "#2e7d32" : "#f57c00",
                                    color: vac.isApproved ? "#2e7d32" : "#f57c00",
                                    "& .MuiChip-icon": { ml: 0.3, mr: 0.3 },
                                    "& .MuiChip-label": { px: 0.5 },
                                  }}
                                />
                              );
                            } */}

                            return row.status ? (
                              <Chip
                                label={
                                  row.status === 1
                                    ? "Posted"
                                    : row.status === 2
                                      ? "Machine"
                                      : row.status === 3
                                        ? "Site"
                                        : row.status === "Weekend"
                                          ? "Weekend"
                                          : row.status
                                }
                                color={
                                  row.status === 1
                                    ? "success"
                                    : row.status === 2
                                      ? "info"
                                      : row.status === 3
                                        ? "warning"
                                        : row.status === "Weekend"
                                          ? "default"
                                          : "default"
                                }
                                size="small"
                                sx={{
                                fontSize: { xs: 8, sm: 12 },
                                height: { xs: 18, sm: 22 },
                                fontWeight: 700,
                                minWidth: { xs: 0, sm: 80 },
                                px: { xs: 0.5, sm: 1 },
                                justifyContent: "center",
                                "& .MuiChip-label": { px: 0.5 },
                              }}
                              />
                            ) : (
                              ""
                            );
                          })()}
                        </TableCell>

                        {/* ✅ Actions */}
                        <TableCell align="center">
                          {row.status === "Weekend" ? null : (
                            <Stack
                              direction="row"
                              spacing={0.5}
                              alignItems="center"
                              justifyContent="center"
                              flexWrap="wrap"
                              useFlexGap
                              sx={{ rowGap: 0.5 }}
                            >
                              {row.isLeave && (
                                <Chip
                                  label="Approved"
                                  size="small"
                                  color="error"
                                  variant="outlined"
                                  sx={{
                                    fontWeight: 800,
                                    minWidth: { xs: 50, sm: 90 },
                                    fontSize: { xs: 9, sm: 12 },
                                    height: { xs: 18, sm: 24 },
                                  }}
                                />
                              )}

                              {requestedDates.includes(row.date) && (
                                <Box
                                  sx={{ display: "flex", alignItems: "center", justifyContent: "center", position: "relative" }}
                                >
                                  <Typography
                                    variant="caption"
                                    sx={{
                                      fontWeight: "bold",
                                      color: "#f57c00",
                                      fontSize: { xs: 9, sm: 12 },
                                      transition: "padding-right 0.3s",
                                      pr: hoveredRow === row.date ? 3 : 0,
                                    }}
                                  >
                                    Requested
                                  </Typography>

                                  <IconButton
                                    onClick={async () => {
                                      await db.vacationRequests.where("date").equals(row.date).delete();
                                      setRequestedDates((prev) => prev.filter((d) => d !== row.date));
                                    }}
                                    size="small"
                                    sx={{
                                      position: "absolute",
                                      right: 4,
                                      top: "50%",
                                      transform: "translateY(-50%)",
                                      backgroundColor: "#ffebee",
                                      color: "#d32f2f",
                                      transition: "opacity 0.3s ease-in-out, right 0.3s",
                                      opacity: hoveredRow === row.date ? 1 : 0,
                                      pointerEvents: hoveredRow === row.date ? "auto" : "none",
                                    }}
                                  >
                                    <CancelIcon fontSize="small" />
                                  </IconButton>
                                </Box>
                              )}

                              <Tooltip title="Add Attendance / Leave">
                                <span>
                                  <IconButton
                                    onClick={() => {
                                      setVacationDate(row.date);
                                      setVacationRawTime(row.time || "");
                                      setVacationRawStatus(row.status || "");
                                      setVacationStampModules(row.stampModules || "");
                                      setRemark("");
                                      setOpenDialog(true);
                                    }}
                                    size="small"
                                    sx={{
                                      backgroundColor: "#e8f5e9",
                                      color: "#388e3c",
                                      "&:hover": { backgroundColor: "#c8e6c9" },
                                      p: { xs: 0.5, sm: 1 },
                                    }}
                                  >
                                    <AddIcon sx={{ fontSize: { xs: 14, sm: 20 } }} />
                                  </IconButton>
                                </span>
                              </Tooltip>
                            </Stack>
                          )}
                        </TableCell>
                      </TableRow>
                    );
                  })}
                </TableBody>
              </Table>
            </TableContainer>
          )}

          
     {/* Footer summary */}
          <Box
            sx={{
              mt: 3,
              p: 2,
              borderRadius: 2,
              backgroundColor: "#e0f2f1",
              borderLeft: "6px solid #00796b",
            }}
          >
            {/* Row 1: Total Hours */}
            <Stack direction="row" alignItems="center" gap={1.5}>
              <AccessTimeFilledIcon sx={{ color: "#00796b" }} />
              <Typography variant="subtitle1" fontWeight={800} sx={{ color: "#004d40" }}>
                Total Hours: {totalHours.toFixed(2)} hrs
              </Typography>
            </Stack>

            {leaveItems.length > 0 && (
              <>
                <Divider sx={{ my: 1, opacity: 0.3 }} />
                  <Stack direction="row" alignItems="center" gap={1} sx={{ mb: 1 }}>
                    <Box
                      sx={{
                        width: 26,
                        height: 26,
                        borderRadius: 1.5,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        bgcolor: "#00796b",
                      }}
                    >
                      <BeachAccessIcon sx={{ color: "#fff", fontSize: 15 }} />
                    </Box>
                    <Box>
                      <Typography sx={{ fontSize: 13, fontWeight: 800, color: "#004d40", lineHeight: 1.2 }}>
                        Leave Balance
                      </Typography>
                      <Typography sx={{ fontSize: 10.5, color: "#4f7d78", lineHeight: 1.2 }}>
                        Tap a card for details
                      </Typography>
                    </Box>
                  </Stack>

                  <Box
                    sx={{
                      display: "grid",
                      gridTemplateColumns: {
                        xs: "repeat(3, 1fr)",
                        sm: "repeat(4, 1fr)",
                        md: "repeat(6, 1fr)",
                      },
                      gap: { xs: 0.75, sm: 1.25 },
                    }}
                  >
                    {leaveItems.map((item) => {
                      const total = Number(item.days_per_year || 0);
                      const remaining = Number(item.remaining || 0);
                      const used = Number(item.used || 0);
                      const pct = total > 0 ? Math.max(0, Math.min(100, (remaining / total) * 100)) : 0;
                      const state = remaining <= 0 ? "empty" : pct <= 20 ? "low" : "ok";
                      const pal = {
                        ok: { main: "#00796b", soft: "#e0f2f1", label: "Available" },
                        low: { main: "#ef6c00", soft: "#fff3e0", label: "Running low" },
                        empty: { main: "#c62828", soft: "#ffebee", label: "Used up" },
                      }[state];
                      const fmtNum = (n) => (n % 1 === 0 ? n : n.toFixed(1));
                      const ringSize = isXs ? 40 : 52;
                      const isSelected = leaveDetail?.leaveid === item.leaveid;
                      return (
                        <Box
                          key={item.leaveid}
                          onClick={() => setLeaveDetail(item)}
                          sx={{
                            position: "relative",
                            overflow: "hidden",
                            cursor: "pointer",
                            borderRadius: 2,
                            pt: { xs: 1, sm: 1.25 },
                            pb: { xs: 0.75, sm: 1 },
                            px: 0.5,
                            bgcolor: "#fff",
                            border: `1px solid ${isSelected ? pal.main : "#cfe8e5"}`,
                            boxShadow: isSelected ? `0 0 0 2px ${pal.soft}` : "none",
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center",
                            gap: 0.5,
                            transition: "border-color .15s ease, box-shadow .15s ease",
                            "&::before": {
                              content: '""',
                              position: "absolute",
                              top: 0,
                              left: 0,
                              right: 0,
                              height: 3,
                              bgcolor: pal.main,
                            },
                            "&:hover": { borderColor: pal.main },
                          }}
                        >
                          <Typography
                            sx={{
                              color: "#004d40",
                              fontWeight: 700,
                              fontSize: { xs: 10, sm: 11 },
                              textAlign: "center",
                              lineHeight: 1.2,
                              width: "100%",
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                              whiteSpace: "nowrap",
                            }}
                          >
                            {item.leavename}
                          </Typography>

                          <Box sx={{ position: "relative", display: "inline-flex" }}>
                            <CircularProgress
                              variant="determinate"
                              value={100}
                              size={ringSize}
                              thickness={4}
                              sx={{ color: pal.soft }}
                            />
                            <CircularProgress
                              variant="determinate"
                              value={pct}
                              size={ringSize}
                              thickness={4}
                              sx={{
                                color: pal.main,
                                position: "absolute",
                                left: 0,
                                "& .MuiCircularProgress-circle": { strokeLinecap: "round" },
                              }}
                            />
                            <Box
                              sx={{
                                position: "absolute",
                                inset: 0,
                                display: "flex",
                                flexDirection: "column",
                                alignItems: "center",
                                justifyContent: "center",
                              }}
                            >
                              <Typography
                                sx={{
                                  fontWeight: 800,
                                  color: pal.main,
                                  lineHeight: 1,
                                  fontSize: Math.abs(remaining) >= 100
                                    ? (isXs ? 11 : 13)
                                    : (isXs ? 13 : 16),
                                }}
                              >
                                {fmtNum(remaining)}
                              </Typography>
                              {!isXs && (
                                <Typography sx={{ fontSize: 8, color: "#6b8f8a", fontWeight: 600, mt: 0.25 }}>
                                  days left
                                </Typography>
                              )}
                            </Box>
                          </Box>

                          {!isXs && (
                            <Stack
                              direction="row"
                              alignItems="center"
                              spacing={0.5}
                              sx={{ px: 0.75, py: 0.1, borderRadius: 10, bgcolor: pal.soft }}
                            >
                              <Box sx={{ width: 5, height: 5, borderRadius: "50%", bgcolor: pal.main }} />
                              <Typography sx={{ fontSize: 9.5, fontWeight: 700, color: pal.main }}>
                                {pal.label}
                              </Typography>
                            </Stack>
                          )}

                          <Typography sx={{ fontSize: { xs: 9.5, sm: 10.5 }, color: "#6b8f8a", lineHeight: 1 }}>
                            {fmtNum(used)} / {fmtNum(total)}
                          </Typography>
                        </Box>
                      );
                    })}
                  </Box>
                {/* <Divider sx={{ my: 1.5, opacity: 0.3 }} />
                <Stack direction="row" alignItems="center" justifyContent="space-between" sx={{ mb: 1.5 }}>
                  <Stack direction="row" alignItems="center" gap={1.25}>
                    <Box
                      sx={{
                        width: 32,
                        height: 32,
                        borderRadius: 2,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        bgcolor: "#00796b",
                        boxShadow: "0 4px 10px rgba(0,121,107,.25)",
                      }}
                    >
                      <BeachAccessIcon sx={{ color: "#fff", fontSize: 18 }} />
                    </Box>
                    <Box>
                      <Typography variant="subtitle2" fontWeight={800} sx={{ color: "#004d40", lineHeight: 1.2 }}>
                        Leave Balance
                      </Typography>
                      <Typography variant="caption" sx={{ color: "#4f7d78" }}>
                        Tap a card for details
                      </Typography>
                    </Box>
                  </Stack>
                </Stack>

                <Box
                  sx={{
                    display: "grid",
                    gridTemplateColumns: {
                      xs: "repeat(3, 1fr)",
                      sm: "repeat(4, 1fr)",
                      md: "repeat(6, 1fr)",
                    },
                    gap: { xs: 1, sm: 1.5 },
                  }}
                >
                  {leaveItems.map((item) => {
                    const total = Number(item.days_per_year || 0);
                    const remaining = Number(item.remaining || 0);
                    const used = Number(item.used || 0);
                    const pct = total > 0 ? Math.max(0, Math.min(100, (remaining / total) * 100)) : 0;
                    const state = remaining <= 0 ? "empty" : pct <= 20 ? "low" : "ok";
                    const pal = {
                      ok: { main: "#00796b", soft: "#e0f2f1", label: "Available" },
                      low: { main: "#ef6c00", soft: "#fff3e0", label: "Running low" },
                      empty: { main: "#c62828", soft: "#ffebee", label: "Used up" },
                    }[state];
                    const fmtNum = (n) => (n % 1 === 0 ? n : n.toFixed(1));
                    const isSelected = leaveDetail?.leaveid === item.leaveid;
                    return (
                      <Box
                        key={item.leaveid}
                        onClick={() => setLeaveDetail(item)}
                        sx={{
                          position: "relative",
                          overflow: "hidden",
                          cursor: "pointer",
                          borderRadius: 3,
                          pt: { xs: 1.5, sm: 2 },
                          pb: { xs: 1.25, sm: 1.5 },
                          px: 0.75,
                          bgcolor: "#fff",
                          border: `1px solid ${isSelected ? pal.main : "#cfe8e5"}`,
                          boxShadow: isSelected
                            ? `0 0 0 3px ${pal.soft}`
                            : "0 1px 3px rgba(0,77,64,.06)",
                          display: "flex",
                          flexDirection: "column",
                          alignItems: "center",
                          gap: 0.75,
                          transition: "transform .18s ease, box-shadow .18s ease, border-color .18s ease",
                          "&::before": {
                            content: '""',
                            position: "absolute",
                            top: 0,
                            left: 0,
                            right: 0,
                            height: 4,
                            bgcolor: pal.main,
                          },
                          "&:hover": {
                            transform: "translateY(-2px)",
                            boxShadow: "0 8px 20px rgba(0,77,64,.12)",
                            borderColor: pal.main,
                          },
                        }}
                      >
                        <Typography
                          sx={{
                            color: "#004d40",
                            fontWeight: 800,
                            fontSize: { xs: 10.5, sm: 12 },
                            textTransform: "uppercase",
                            letterSpacing: 0.5,
                            textAlign: "center",
                            lineHeight: 1.2,
                            minHeight: { xs: 26, sm: 30 },
                            display: "flex",
                            alignItems: "center",
                          }}
                        >
                          {item.leavename}
                        </Typography>

                        <Box sx={{ position: "relative", display: "inline-flex" }}>
                          <CircularProgress
                            variant="determinate"
                            value={100}
                            size={64}
                            thickness={4.5}
                            sx={{ color: pal.soft }}
                          />
                          <CircularProgress
                            variant="determinate"
                            value={pct}
                            size={64}
                            thickness={4.5}
                            sx={{
                              color: pal.main,
                              position: "absolute",
                              left: 0,
                              "& .MuiCircularProgress-circle": { strokeLinecap: "round" },
                            }}
                          />
                          <Box
                            sx={{
                              position: "absolute",
                              inset: 0,
                              display: "flex",
                              flexDirection: "column",
                              alignItems: "center",
                              justifyContent: "center",
                            }}
                          >
                            <Typography
                              sx={{
                                fontWeight: 800,
                                color: pal.main,
                                lineHeight: 1,
                                fontSize: Math.abs(remaining) >= 100 ? 15 : 19,
                              }}
                            >
                              {fmtNum(remaining)}
                            </Typography>
                            <Typography sx={{ fontSize: 8.5, color: "#6b8f8a", fontWeight: 600, mt: 0.25 }}>
                              days left
                            </Typography>
                          </Box>
                        </Box>

                        <Stack
                          direction="row"
                          alignItems="center"
                          spacing={0.5}
                          sx={{ px: 1, py: 0.25, borderRadius: 10, bgcolor: pal.soft }}
                        >
                          <Box sx={{ width: 6, height: 6, borderRadius: "50%", bgcolor: pal.main }} />
                          <Typography sx={{ fontSize: { xs: 9.5, sm: 10.5 }, fontWeight: 700, color: pal.main }}>
                            {pal.label}
                          </Typography>
                        </Stack>

                        <Typography sx={{ fontSize: { xs: 10, sm: 11.5 }, color: "#6b8f8a" }}>
                          {fmtNum(used)} used · {fmtNum(total)} total
                        </Typography>
                      </Box>
                    );
                  })}
                </Box> */}
                

                <Dialog
                  open={!!leaveDetail}
                  onClose={() => setLeaveDetail(null)}
                  maxWidth="xs"
                  fullWidth
                  PaperProps={{ sx: { borderRadius: 3, overflow: "hidden" } }}
                >
                  {leaveDetail && (() => {
                    const r = Number(leaveDetail.remaining || 0);
                    const t = Number(leaveDetail.days_per_year || 0);
                    const p = t > 0 ? Math.max(0, Math.min(100, (r / t) * 100)) : 0;
                    const barColor = r <= 0 ? "#ff8a80" : p <= 20 ? "#ffcc80" : "#a7ffeb";
                    return (
                      <>
                        <Box
                          sx={{
                            position: "relative",
                            px: 3,
                            pt: 2.5,
                            pb: 2.5,
                            color: "#fff",
                            background: "linear-gradient(135deg, #00796b 0%, #004d40 100%)",
                          }}
                        >
                          <IconButton
                            size="small"
                            onClick={() => setLeaveDetail(null)}
                            sx={{ position: "absolute", top: 10, right: 10, color: "rgba(255,255,255,.85)" }}
                          >
                            <CloseIcon fontSize="small" />
                          </IconButton>
                          <Typography sx={{ fontSize: 11, letterSpacing: 1.2, textTransform: "uppercase", opacity: 0.8 }}>
                            Leave balance
                          </Typography>
                          <Typography variant="h6" fontWeight={800}>
                            {leaveDetail.leavename}
                          </Typography>
                          <Stack direction="row" alignItems="baseline" spacing={1} sx={{ mt: 1 }}>
                            <Typography sx={{ fontSize: 38, fontWeight: 800, lineHeight: 1 }}>{r}</Typography>
                            <Typography sx={{ opacity: 0.85 }}>of {t} days left</Typography>
                          </Stack>
                          <LinearProgress
                            variant="determinate"
                            value={p}
                            sx={{
                              mt: 1.5,
                              height: 6,
                              borderRadius: 3,
                              bgcolor: "rgba(255,255,255,.25)",
                              "& .MuiLinearProgress-bar": { bgcolor: barColor, borderRadius: 3 },
                            }}
                          />
                        </Box>
                        <DialogContent sx={{ pt: 2 }}>
                          {detailRow("Rule days", leaveDetail.rule_days)}
                          {Number(leaveDetail.starting_balance) > 0 &&
                            detailRow("Starting balance", `-${leaveDetail.starting_balance}`, {
                              color: "#c62828",
                              sub: leaveDetail.starting_balance_from
                                ? `from ${fmtDMY(leaveDetail.starting_balance_from)}`
                                : "",
                            })}
                          {Number(leaveDetail.bonus) > 0 &&
                            detailRow("Bonus", `+${leaveDetail.bonus}`, {
                              color: "#2e7d32",
                              sub: leaveDetail.bonus_from ? `from ${fmtDMY(leaveDetail.bonus_from)}` : "",
                            })}
                          {detailRow("Total", t, { bold: true, top: true })}
                          {detailRow("Used ", `-${leaveDetail.used}`)}
                          <Stack
                            direction="row"
                            alignItems="center"
                            spacing={1}
                            sx={{ mt: 2, p: 1.25, borderRadius: 2, bgcolor: "#f1fdfb", border: "1px solid #b2dfdb" }}
                          >
                            <EventIcon sx={{ fontSize: 18, color: "#00796b" }} />
                            <Typography variant="caption" sx={{ color: "#004d40" }}>
                              Period {fmtDMY(leaveDetail.count_from)} to {fmtDMY(leaveDetail.count_to)} ·{" "}
                              {Number(leaveDetail.leave_limit) === 1 ? "fiscal year" : "employee's year"}
                            </Typography>
                          </Stack>
                        </DialogContent>
                      </>
                    );
                  })()}
                </Dialog>
              </>
            )}
          </Box>
        </Box>
      </Paper>

      {/* <VacationDialog
        open={openDialog}
        onClose={() => setOpenDialog(false)}
        setError={setError}
        vacationDate={vacationDate}
        onDone={fetchData}
        onRequested={(date) =>
          setRequestedDates((prev) =>
            prev.includes(date) ? prev : [...prev, date],
          )
        }
      /> */}
      <EmployeeEntryDialog
      open={openDialog}
      onClose={() => setOpenDialog(false)}
      //setError={setError}
      isoDate={vacationDate}
      empId={selectedEmployee?.empId || Number(localStorage.getItem("shared_empid")) || null}
      onSave={fetchData}
      initialDate={vacationDate}
      initialRawTime={vacationRawTime}
      initialRawStatus={vacationRawStatus}
      initialStampModules={vacationStampModules}
      />
    </Box>
  );
}     